import styled from 'styled-components';
import { AutoComplete as autoComplete } from 'antd';

const AutoComplete = styled(autoComplete)``;

/** @component */
export default AutoComplete;
